export const QueryKeys = {
    SHIPMENT_FACETS: "shipmentFacets",
} as const;